import { render, staticRenderFns } from "./ConfigurationSection.vue?vue&type=template&id=3bdb0f1e&scoped=true"
import script from "./ConfigurationSection.vue?vue&type=script&lang=js"
export * from "./ConfigurationSection.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationSection.vue?vue&type=style&index=0&id=3bdb0f1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdb0f1e",
  null
  
)

export default component.exports